import { useEffect, Fragment } from 'react';
import { useLazyGetCustomerInfoQuery } from '@api/shipping-data/detailApi';
import ErrorElement from 'components/base-elements/error/ErrorElement';
import LoadingElement from 'components/base-elements/loading/LoadingElement';
import { formatPhoneNumber, capitalizeFirstChar } from 'components/global/utils';
import { getDayName } from '@translations/functions';



interface CustomerInfoProps {
	destinationSystemId: string,
}


export const CustomerInfo = (props: CustomerInfoProps) => {
	const { destinationSystemId } = props;

	const [ getCustomerInfo, { data, isLoading, isFetching, isError }] = useLazyGetCustomerInfoQuery();


	useEffect(() => {
		if (destinationSystemId) {
			getCustomerInfo({ systemId: destinationSystemId }, true);
		}
	}, [ destinationSystemId ]);


	if (isError) return (
		<div className='detail-area-empty'>
			<ErrorElement />
		</div>
	);

	
	if (isLoading || isFetching) return (
		<div className='detail-area-empty'>
			<LoadingElement />
		</div>
	);

	
	if (!data) return (
		<p className='detail-area-empty'>Žádná data k dispozici</p>
	);


	return (
		<div className='customer-info-block'>
			<div className='customer-info-label'>Zákazník:</div>
			<div>
				<p>{data.clientId ?? '-'}</p>
				<p>{data.companyName ?? '-'}</p>
				<br />

				{data.addressess[0] && data.addressess[0].street &&
					<p>{data.addressess[0].street}</p>}
				{data.addressess[0] && data.addressess[0].city &&
					<p>{data.addressess[0].city}</p>}
				{data.addressess[0] && data.addressess[0].zipCode &&
					<p>{data.addressess[0].zipCode ?? ''}</p>}
				<br />

				{data.contacts && data.contacts.length > 0 && data.contacts.map((x, i) =>
					<Fragment key={`${data.clientId}-${i}`}>
						{(x.firstName || x.lastName) && <p>{
							x.firstName && x.lastName
							? `${x.firstName} ${x.lastName}`
							: x.lastName
							? `${x.lastName}`
							: `${x.firstName}`
							}</p>}
						{x.phoneNumbers && x.phoneNumbers.map(y => y
							? <p key={`${data.clientId}-${i}-${y}`}>{formatPhoneNumber(y)}</p>
							: <></>
						)}
						{x.emails && x.emails.map(z => z
							? <p key={`${data.clientId}-${i}-${z}`}>{z}</p>
							: <></>
						)}
						<br />
					</Fragment>
				)}
			</div>

			<div className='customer-info-label'>KA:</div>
			<div>
				{data.isKA ? 'Ano' : 'Ne'}
			</div>

			<div className='customer-info-label'>Závozová okna:</div>
			<div>
				{data.windows && data.windows.length > 0 && data.windows.map((x, i) => 
					<Fragment key={`${data.clientId}-${i}`}>
						{x.type && <p>Kategorie: {x.type}</p>}
						<p>{capitalizeFirstChar(getDayName(x.dayOfWeek))} {x.from.slice(0, -3)} - {x.to.slice(0, -3)}</p>
						{x.note && <p>{x.note}</p>}
						<br />
					</Fragment>
				)}
			</div>
		</div>
	)
}